import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { BrowserView, MobileView } from 'react-device-detect';
import API from '../../utils/API';

// Core components
import DashboardLayout from '../../components/DashboardLayout/DashboardLayout';
// import OverviewCards from '../../components/DashboardLayout/OverviewCards/OverviewCards';
import ActionSection from '../../components/DashboardLayout/ActionSection/ActionSection';
import DonationsTable from '../../components/DashboardLayout/DonationsTable/DonationsTable';

// Dashboard page components
import DesktopInstallPopup from './desktopInstallPopup';
import ManageWishlistPopup from './manageWishlistPopup/ManageWishlistPopup';
import ManageMarketPlacePopup from './manageMarketPlacePopup/ManageMarketPlacePopup';
import QuickSharePopup from './quickSharePopup/QuickSharePopup';
import WhatsNewPopup from './whatsNewPopup/WhatsNewPopup';
import DashboardSetting from './dashboardSetting/DashboardSetting';
import MobileDashboard from './MobileDashboard';
import One from '../../images/newLogin/1.png';
import two from '../../images/newLogin/2.png';
import three from '../../images/newLogin/3.png';
import six from '../../images/newLogin/6.png';
import seven from '../../images/newLogin/7.png';
import eight from '../../images/newLogin/8.png';
import nine from '../../images/newLogin/9.png';
import ten from '../../images/newLogin/10.png';
import 'react-multi-carousel/lib/styles.css';
import Carousel from 'react-multi-carousel';

// Image imports

import './dashboard.css';
import { useHistory } from 'react-router-dom';
import { Modal } from 'react-bootstrap';

// Type definitions from ActionSection
interface ShareItem {
  id: string;
  title: string;
  icon: React.ReactNode;
  onClick: () => void;
  variant?: 'tile' | 'fundraiser';
  accent?: 'orange' | 'pink' | 'green' | 'purple';
}

const DasgboardNonprofit: React.FC = (props: any) => {
  const reduxOrg = useSelector((state: any) => state.org);
  const history = useHistory();
  // Modal states (keeping existing functionality)
  const [wishList, setWishList] = useState(false);
  const [marketPlace, setMarketPlace] = useState(false);
  const [shareLink, setShareLink] = useState(false);
  const [whatsNew, setWhatsNew] = useState(false);
  const [dashboardSetting, setDashboardSetting] = useState(false);
  // const [show, setShow] = useState(false);

  // Desktop install popup
  const [desktopInstallMessage, setDesktopInstallMessage] = useState(false);
  const reduxInstallPrompt = useSelector((state: any) => state.displayInstallPrompt);

  // Donations state
  const [recurringDonations, setRecurringDonations] = useState<any[]>([]);
  const [duration, setDuration] = useState('all');
  const [fundraiser, setFundraiser] = useState('all');
  const [campaigns, setCampaigns] = useState<any[]>([]);
  const [dynamicFundraiserItems, setDynamicFundraiserItems] = useState<ShareItem[]>([]);
  const [customStartDate, setCustomStartDate] = useState('');
  const [customEndDate, setCustomEndDate] = useState('');
  const [fetchingData, setFetchingData] = useState(false);
  const [onboardComplete, setOnboardComplete] = useState(false);
  const [onboardPaypalComplete, setOnboardPaypalComplete] = useState(false);

  // detect viewer timezone
  const userTz = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';

  const png = (src: string, alt: string) => (
    <img src={src} alt={alt} className="nav-img" loading="lazy" />
  );

  // Fetch campaigns
  useEffect(() => {
    if (reduxOrg?._id) {
      API.getNpCampaigns(reduxOrg._id).then((result) => {
        const sortedCampaigns = result.data.sort((a: any, b: any) => b.createdAt - a.createdAt);
        setCampaigns(sortedCampaigns);
        console.log(sortedCampaigns, 'sortedCampaigns');

        // Create dynamic fundraiser items from campaigns
        const fundraiserItems: ShareItem[] = sortedCampaigns.slice(0, 2).map((campaign: any) => ({
          id: 'fundraiser',
          campaignId: campaign.id,
          title: campaign.name,
          icon: 'flag',
          onClick: () => history.push(`/donation/${reduxOrg._id}/default`),
          variant: 'fundraiser' as const,
          accent: 'purple' as const
        }));

        setDynamicFundraiserItems(fundraiserItems);
      });

      console.log({ reduxOrg });

      if (reduxOrg.stripeComplete) {
        setOnboardComplete(true);
      }
      if (reduxOrg?.paypal?.merchantId) {
        setOnboardPaypalComplete(true)
      }
    }
  }, [reduxOrg?._id, history]);

  // Desktop install detection
  useEffect(() => {
    const isDesktop = () => {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /Mozilla5.0 (Linux; Android 8.0; Pixel 2 Build|OPD3.170816.012) AppleWebKit|537.36 (KHTML, like Gecko) Chrome|86.0.4240.198 Mobile Safari|537.36/.test(
        userAgent
      );
    };

    const newNavigator: any = window.navigator;
    const isInStandaloneMode = () => newNavigator.standalone;

    if (isDesktop() && !isInStandaloneMode() && !(reduxInstallPrompt % 5)) {
      setDesktopInstallMessage(true);
    }
  }, []);

  // Fetch all donations (one-time and recurring)
  useEffect(() => {
    if (reduxOrg?._id) {
      // Skip fetching if custom duration is selected but dates are not set
      if (duration === 'custom' && (!customStartDate || !customEndDate)) {
        return;
      }
      setFetchingData(true);
      if (duration === 'custom') {
        if (customStartDate && customEndDate) {
          const query = `duration=${duration}&fundraiser=${fundraiser}&startDate=${customStartDate}&endDate=${customEndDate}`;
          // include viewer tz so server can compute day boundaries in user's timezone if desired
          const tzQuery = `${query}&tz=${encodeURIComponent(userTz)}`;
          API.getAllDonationsForNp(reduxOrg._id, tzQuery)
            .then((response) => {
              setRecurringDonations(response.data);
            })
            .catch((err) => {
              console.log('Error fetching donations:', err);
            })
            .finally(() => setFetchingData(false));
        } else {
          // Fetch all donations when custom is selected but dates are not set
          const query = `duration=all&fundraiser=${fundraiser}`;
          // include viewer tz so server can compute day boundaries in user's timezone if desired
          const tzQuery = `${query}&tz=${encodeURIComponent(userTz)}`;
          API.getAllDonationsForNp(reduxOrg._id, tzQuery)
            .then((response) => {
              setRecurringDonations(response.data);
            })
            .catch((err) => {
              console.log('Error fetching donations:', err);
            })
            .finally(() => setFetchingData(false));
        }
      } else {
        const query = `duration=${duration}&fundraiser=${fundraiser}`;
        // include viewer tz so server can compute day boundaries in user's timezone if desired
        const tzQuery = `${query}&tz=${encodeURIComponent(userTz)}`;
        API.getAllDonationsForNp(reduxOrg._id, tzQuery)
          .then((response) => {
            setRecurringDonations(response.data);
          })
          .catch((err) => {
            console.log('Error fetching donations:', err);
          })
          .finally(() => setFetchingData(false));
      }
    }
  }, [reduxOrg?._id, duration, fundraiser, customStartDate, customEndDate, userTz]);

  // const handleShowReport = () => {
  //   console.log('Show report clicked');
  // };

  const handleDownloadReport = () => {
    console.log('Download report clicked');
  };

  // ---- Demo data for the 4 cards ----

  const demoOverview = {
    yearDonations: 10000,
    supporters: 200,
    allDonations: 50000,
  };

  const demoKeyActions = [
    { id: 'edit', title: 'Edit My Profile', icon: 'user', color: 'orange', onClick: () => history.push(`/nonprofit/${reduxOrg?._id}`) },
    { id: 'pay', title: 'Connect Payments', icon: 'credit-card', color: 'green', onClick: () => history.push('/connect-payments') },
    { id: 'grants', title: 'Search For Grants', icon: 'search', color: 'purple', onClick: () => window.open('https://www.neddieblog.com/grant-central-search', '_blank') },
  ];

  const demoFundraiserProgress = [
    { id: 'children', title: 'Help Children in need', progress: 50, goal: 10000, raised: 5000, description: '' },
    { id: 'meal', title: 'Donate a meal', progress: 30, goal: 10000, raised: 3000, description: '' },
    { id: 'meal', title: 'Donate a meal', progress: 30, goal: 10000, raised: 3000, description: '' },
    { id: 'meal', title: 'Donate a meal', progress: 30, goal: 10000, raised: 3000, description: '' },
  ];

  // Dynamic social share items combining static tiles with dynamic fundraisers
  const dynamicSocialShareItems: ShareItem[] = [
    // top tiles (static)
    { id: 'profile', title: 'Profile', icon: png('/icons/38.png', 'Profile'), onClick: () => console.log('Profile'), variant: 'tile', accent: 'orange' },
    { id: 'wishlist', title: 'Wishlist', icon: png('/icons/40.png', 'Wishlist'), onClick: () => console.log('Wishlist'), variant: 'tile', accent: 'pink' },
    { id: 'store', title: 'Store', icon: png('/icons/39.png', 'Store'), onClick: () => console.log('Store'), variant: 'tile', accent: 'green' },
    // fundraiser rows (dynamic)
    ...dynamicFundraiserItems,
  ];

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 6500, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    }
  };

  const [showPopup, setShowPopup] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const carouselRef = useRef<any>(null);

  const slides = [
    One,
    two,
    three,
    six,
    seven,
    eight,
    nine,
    ten,
  ];

  // SHOW POPUP ONLY FIRST LOGIN
  useEffect(() => {
    const seen = localStorage.getItem("introSeen");
    if (!seen) {
      setShowPopup(true);
    }
  }, []);

  const closePopup = () => {
    localStorage.setItem("introSeen", "true");
    setShowPopup(false);
  };

  console.log(showPopup);

  // if (!showPopup) return null;

  const isFirst = currentSlide === 0;
  const isLast = currentSlide === slides.length - 1;


  return (
    <>
      <BrowserView style={{ height: '100%' }}>
        <DashboardLayout>
          {/* Overview Cards */}
          {/* <OverviewCards cards={overviewData} /> */}

          {/* Action Section */}
          <ActionSection
            keyActions={demoKeyActions}
            fundraiserProgress={demoFundraiserProgress}
            socialShareItems={dynamicSocialShareItems}
            overview={demoOverview}
          />

          {/* Donations Table */}
          <div style={{ position: 'relative' }}>
            {fetchingData && (
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000,
                borderRadius: '12px'
              }}>
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '10px'
                }}>
                  <div className="spinner-border text-primary" role="status">

                  </div>

                </div>
              </div>
            )}
            <DonationsTable
              donations={recurringDonations}
              // onShowReport={handleShowReport}
              onDownloadReport={handleDownloadReport}
              duration={duration}
              setDuration={setDuration}
              fundraiser={fundraiser}
              setFundraiser={setFundraiser}
              campaigns={campaigns}
              npID={reduxOrg._id}
              enableCustomDate={true}
              customStartDate={customStartDate}
              setCustomStartDate={setCustomStartDate}
              customEndDate={customEndDate}
              setCustomEndDate={setCustomEndDate}
              isOnboardingComplete={onboardComplete || onboardPaypalComplete}
            />
          </div>
        </DashboardLayout>

        {desktopInstallMessage && (
          <DesktopInstallPopup close={() => setDesktopInstallMessage(false)} />
        )}
      </BrowserView>
      <MobileView>
        <MobileDashboard />
      </MobileView>
      <ManageWishlistPopup wishList={wishList} setWishList={setWishList} />
      <ManageMarketPlacePopup marketPlace={marketPlace} setMarketPlace={setMarketPlace} />
      <QuickSharePopup shareLink={shareLink} setShareLink={setShareLink} />
      <WhatsNewPopup whatsNew={whatsNew} setWhatsNew={setWhatsNew} />
      <DashboardSetting dashboardSetting={dashboardSetting} setDashboardSetting={setDashboardSetting} />

      <Modal
        show={showPopup}
        // show={true}
        size="lg"
        centered
        className='intro-slider'
      >
        <Carousel
          ref={carouselRef}
          responsive={responsive}
          arrows={false}
          swipeable={false}
          draggable={false}
          beforeChange={(nextSlide) => setCurrentSlide(nextSlide)}
          renderButtonGroupOutside
          customButtonGroup={
            <div className="buttons">
              <button
                onClick={() => carouselRef.current?.previous()}
                disabled={isFirst}
                className={`${isFirst ? "disable" : ""}`}
              >
                Prev
              </button>

              {!isLast ? (
                <button onClick={() => carouselRef.current?.next()}>
                  Next
                </button>
              ) : (
                <button onClick={closePopup}>Close</button>
              )}
            </div>
          }
        >
          {slides.map((img, index) => (
            <div className="slide" key={index}>
              <img src={img} alt="" className='intro-slider-image' loading='lazy' />
            </div>
          ))}
        </Carousel>
      </Modal>
    </>
  );
};

export default DasgboardNonprofit;